import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/pages/Home/Home';
import Appointment from '@/pages/Appointment/Appointment';
import CitizenAccount from '@/pages/CitizenAccount/CitizenAccount';
import AuthoritySub from '@/pages/AuthoritySub/AuthoritySub';
import PageNotFound from '@/pages/PageNotFound/PageNotFound';
import Authorities from '@/pages/Authorities/Authorities';
import LivingAreas from '@/pages/LivingAreas/LivingAreas';
import LivingArea from '@/pages/LivingArea/LivingArea';
import Authority from '@/pages/Authority/Authority';
import Impressum from '@/pages/Impressum/Impressum';
import Requests from '@/pages/Requests/Requests';
import Settings from '@/pages/Settings/Settings';
import Services from '@/pages/Services/Services';
import Section1 from '@/pages/Section/Section1';
import Section2 from '@/pages/Section/Section2';
import Section3 from '@/pages/Section/Section3';
import Section4 from '@/pages/Section/Section4';
import Section5 from '@/pages/Section/Section5';
import Benefits from '@/pages/Benefits/Benefits';
import Service from '@/pages/Service/Service';
import Postbox from '@/pages/Postbox/Postbox';
import Docbox from '@/pages/Docbox/Docbox';
import Search from '@/pages/Search/Search';

import store from "../store/index";

Vue.use(Router);

function blockSite() {
  return (to, from, next) => {
    const isAuthenticated = store.getters["auth/isAuthenticated"];

    if (isAuthenticated) {
      next();
    } else {
      if (!from.name) {
        next({
          name: "Home"
        });
      } else {
        next(new Error("Access denied."));
      }
    }
  };
}

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/termin-reservieren',
      name: 'Appointment',
      component: Appointment,
    },
    {
      path: '/vorteile',
      name: 'Benefits',
      component: Benefits,
    },
    {
      path: '/behoerden',
      name: 'Authorities',
      component: Authorities,
    },
    {
      path: '/behoerden/:id',
      name: 'Authority',
      component: Authority,
    },
    {
      path: '/behoerden/:id/sub',
      name: 'AuthoritySub',
      component: AuthoritySub,
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
    },
    {
      path: '/services/:id',
      name: 'Service',
      component: Service,
    },
    {
      path: '/services/:id/section-1',
      name: 'Section1',
      component: Section1,
    },
    {
      path: '/services/:id/section-2',
      name: 'Section2',
      component: Section2,
    },
    {
      path: '/services/:id/section-3',
      name: 'Section3',
      component: Section3,
    },
    {
      path: '/services/:id/section-4',
      name: 'Section4',
      component: Section4,
    },
    {
      path: '/services/:id/section-5',
      name: 'Section5',
      component: Section5,
    },
    {
      path: '/lebensbereiche',
      name: 'LivingAreas',
      component: LivingAreas,
    },
    {
      path: '/lebensbereiche/:id',
      name: 'LivingArea',
      component: LivingArea,
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
    },
    {
      path: '/buergerkonto',
      name: 'CitizenAccount',
      component: CitizenAccount,
      beforeEnter: blockSite(),
    },
    {
      path: '/buergerkonto/postbox',
      name: 'Postbox',
      component: Postbox,
      beforeEnter: blockSite(),
    },
    {
      path: '/buergerkonto/dokumentenbox',
      name: 'Docbox',
      component: Docbox,
      beforeEnter: blockSite(),
    },
    {
      path: '/buergerkonto/aktivitaeten',
      name: 'Requests',
      component: Requests,
      beforeEnter: blockSite(),
    },
    {
      path: '/buergerkonto/einstellungen',
      name: 'Settings',
      component: Settings,
      beforeEnter: blockSite(),
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum,
    },
    {
      path: '/datenschutz',
      name: 'Security',
      component: Impressum,
    },

    { path: "/404", component: PageNotFound },
    { path: "*", component: PageNotFound }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js